import { FC } from 'react';
import { HeaderProps } from './types';
import Navbar from '../Navbar';
import { IconInfo } from '@/components/icons';

const Header: FC<HeaderProps> = () => {
  // TODO: once the laravel app is fully migrated change this to pull from .env
  const isDevelopment = !window.location.href.includes('portal.stubbenedge.co');

  return (
    <>
      {isDevelopment && (
        <div className="flex items-center justify-center gap-1 bg-yellow-100 p-2">
          <IconInfo className="h-5 w-6 text-black" />
          <p className="text-sm font-medium text-black">
            You are working on the current system in development mode.
          </p>
        </div>
      )}
      <Navbar />
    </>
  );
};

export default Header;
